export default [
  {
    name: 'Польский',
    level: 'Родной',
    percent: 100,
    flag: 'https://flagcdn.com/w40/pl.png',
  },
  {
    name: 'Английский',
    level: 'C1',
    percent: 80,
    flag: 'https://flagcdn.com/w40/us.png',
    certs: [{ level: '', link: '/certs/english-b2.pdf' }],
  },
  // {
  //   name: 'Норвежский',
  //   level: 'B1+',
  //   percent: 60,
  //   flag: 'https://flagcdn.com/w40/no.png',
  // },
  // {
  //   name: 'Исландский',
  //   level: 'B1',
  //   percent: 50,
  //   flag: 'https://flagcdn.com/w40/is.png',
  // },
  {
    name: 'Немецкий',
    level: 'A2+',
    percent: 35,
    flag: 'https://flagcdn.com/w40/de.png',
  },
  {
    name: 'Японский',
    level: 'A2',
    percent: 25,
    flag: 'https://flagcdn.com/w40/jp.png',
  },
  // {
  //   name: 'Хорватский',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/hr.png',
  // },
  // {
  //   name: 'Русский',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/ru.png',
  // },
]
